import styled from 'styled-components'

export const SquareCheckBox = styled.div<{ active?: boolean }>`
  position: relative;
  width: 1rem;
  height: 1rem;
  padding: 2px;
  border: 1px solid #ff9900;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.active ? props.theme.colorOrange : 'transparent')};
`

export const CheckChipContainer = styled.div<{ active?: boolean }>`
  ${(props) => props.theme.content};
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 5px 10px;
  ${(props) => props.active && 'border:1px solid #ff9900;'}
  cursor: pointer;
`

export const ChipsContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`
